import React from "react";
import "./QuestionnoboxHW.css";

const QuestionnoboxHW = ({ questions, setClickedNo }) => {
  let count = 1;
  const helper = () => {
    return count++;
  };
  const handleClick = (event) => {
    setClickedNo(event.target.value);
  };
  return (
    <div className="d-flex align-items-center published_Subject_container">
      {questions.map((obj) => (
        <button
          value={count}
          onClick={(event) => {
            handleClick(event);
          }}
          className={
            obj.student_attachment?.length !== 0
              ? "numbering_box"
              : "numbering_box_grey"
          }
        >
          Q{helper()}
        </button>
      ))}
    </div>
  );
};

export default QuestionnoboxHW;
